import 'jquery-simplyscroll';
export function indexFunc() {
    var $slider;
    $slider = $('#slideShowLayout');
    $slider.simplyScroll({
        autoMode: 'loop',
        speed :1,
        frameRate: 60,
        pauseOnHover:false,
        pauseOnTouch:false
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_index.js
// module id = 8
// module chunks = 0